import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';
import { get_profile_url } from "@/views/home/home_helper.js";
import CreateSegment from "@/components/CreateSegment/CreateSegment.vue";

export default {
  components: {
    CreateSegment
  },
  mounted() {
    this.fetch_topics();
    this.token_exists = get_token();
    this.user_details=get_user_details();
  },
  props: {
    topics: {
      type: Array,
      required: true
    }},

    watch: {
      '$route.params.portal_id'() {
        this.fetch_topics();
      }
    },

  data() {
    return ({
      topics:[],
      portals: [],
      members: [],
      users:[],
      topic:'',
      topic_id:'',
      portal_id:'',
      is_public: true,
      isLoading: true,
      token_exists: false,
      topic_name: '',
      isSubmitting: false,
      errors: {},
      searchQuery: "",
      portal_creater:'',
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',

      },
      current_portal_permissions:[]
    });
  },


  methods: {
    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
  openEditSegmentModal(topic) {
    this.$refs.createSegment.openEditModal(topic);
  },
  deleteSegment(segment_id) {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      position: 'bottom-end',
      toast: true
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          type: 'DELETE',
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic_api/`,
          data: { topic_id: segment_id },
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          success: (response) => {
            const status = response.status;
            if (status === "success") {
              this.topics = this.topics.filter(topic => topic.id !== segment_id);
            }
          },
          error: () => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to delete the feed. Please try again.',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
      }
    });
  },
  getProfileLink(member) {
    // Check if the user is an admin
    if (member.role.role === 'admin') {
      // Return the link for admin profiles
      return ``;
    } else if (member.role.role === 'user') {
      // Return the link for user profiles
      return get_profile_url(member);
    } else {
      // Return a default profile link for other roles
      return ``;
    }
  },


  handleTopicClick(topicId) {
    this.$emit('topic_selected', topicId);
  },

    fetch_topics() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: {portal_id: this.$route.params.portal_id},
        success: (response) => {
          var status = response.status
          if(status === "success") {
            this.$nextTick(() => {
              this.topics=  response.topics;
               this.current_portal_permissions = response.portal_permissions;
              this.isLoading = false;
            });
          }

        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },

    fetchReportsByTopic(topicId) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_topic/`,
        type: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          topic_id: topicId
        }),
        success: (response) => {
          if (response.status === "success") {
            this.reports = response.reports;
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message || 'Failed to fetch reports',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },


  //   fetchPortals() {
  //     this.isLoading = true;
  //     this.portal_id=this.$route.params.portal_id
  //     $.ajax({
  //     url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
  //     method: 'POST',
  //     headers: {
  //         'Authorization': `Token ${this.getToken()}`,
  //         'Content-Type': 'application/json'
  //     },
  //     success: (data) => {
  //         this.portals = data.portals;
  //         const visible=this.portals.find(portal_id => portal_id.id === parseInt(this.portal_id, 10));
  //         if (visible) {
  //           this.is_public = visible.is_public;
  //         }
  //     },
  //     complete: () => {
  //         this.isLoading = false;
  //     }
  //     });
  // },

  // fetch_users() {
  //   return new Promise((resolve) => {

  //     const portalId = this.$route.params.portal_id;
  //   $.ajax({
  //     type: 'GET',
  //     data:{portal_id:portalId},
  //     url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
  //     headers: {
  //       'Authorization': `Token ${this.getToken()}`,
  //     },
  //     success: (response) => {
  //       this.users = response.data.users_list;
  //       resolve();
  //     },
  //   });
  // });
  // },

    handleSubmit() {
      if (this.validateTopicForm()) {
        this.isSubmitting = true;

        const requestData = {
          topic_name: this.topic_name,
          portal_id: this.$route.params.portal_id
        };
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic_api/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {

          const status = response.status;

          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Segment Created Successfully',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              window.location.reload();
              $('#create_topic').modal('hide');
            });
          } else if (status === "error") {
            Swal.fire({
              icon: 'error',
              title: 'Creation Failed',
              text: response.message || 'An error occurred. Please try again.',
              confirmButtonText: 'Retry',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Unexpected Response',
              text: 'The server returned an unexpected response.',
              confirmButtonText: 'Okay',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if(response_data.status=="error"){
           this.errors.topic_name=response_data.message
          }
      },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    }
   },


  validateTopicForm() {
    this.errors = {};
    let isValid = true;
    if (!this.topic_name.trim()) {
      this.errors.topic_name = 'Segment name is required.';
      isValid = false;
    }
    return isValid;
  },
  },
};
